import 'core-js/stable';
import Vue from 'vue';
import App from './App';
import router from './router';
import CoreuiVue from '@coreui/vue';
import {
    iconsSet as icons
} from './assets/icons/icons.js';
import store from './store';
import { initializeApp } from 'firebase/app';
import { getAuth } from "firebase/auth";



let firebaseConfig = {};

if (process.env.VUE_APP_CONFIG !== null) {
    firebaseConfig = JSON.parse(process.env.VUE_APP_CONFIG);
}

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

auth.onAuthStateChanged(user => {
    let storeItems = store;
    if (user !== null) {
        storeItems.commit('set', ['userData', user]);
        storeItems.commit('changeLoginState', true);
    } else {
        storeItems.commit('changeLoginState', false);
    }
});

Vue.config.performance = true;
Vue.use(CoreuiVue);

new Vue({
    el: '#app',
    router,
    store,
    icons,
    template: '<App/>',
    components: {
        App
    }
})